import StampWorkScheduleChangeApplication from './StampWorkScheduleChangeApplication';

export default StampWorkScheduleChangeApplication;
